import { useTheme } from "@mui/material/styles";
import React, { useEffect, useMemo, useState } from "react";
import ViewEditDialog from "../../../../utils/ui-components/ViewEditDialog";
import {
  Avatar,
  Box,
  Button,
  Grid,
  IconButton,
  InputAdornment,
  LinearProgress,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import MainCard from "../../../../utils/ui-components/MainCard";
import { gridSpacing } from "../../../../store/constants";
import SearchIcon from "@mui/icons-material/Search";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EmptyResult from "../../../../utils/ui-components/EmptyResult";
import Spinner from "../../../../utils/ui-components/Spinner";
import TablePaginationActions from "@mui/material/TablePagination/TablePaginationActions";
import { formatMobile } from "../../../../utils/utils";
import { UserService } from "../../../../assets/_services/user-service";
import ApproveUser from "./approve-owner/approve-user";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import TextFieldWrapper from "../../../../utils/ui-components/FormsUI/TextField";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { MENU_OPEN } from "../../../../redux/actions/actions";
import EmptyResultDataGrid from "../../../../utils/ui-components/EmptyResultDataGrid";
import { DataGrid, GridAlignment } from "@mui/x-data-grid";

export interface UserAddValues {
  id: number;
  username: string;
  email: string;
  representativeName: string;
  companyContact: string;
  accountType: number | string;
  companyName: string;
  profileImage: string;
  businessName: string;
  industryType: string;
  rateCardId: number | string;
  dataRateCardId: number | string;
  status: boolean;
  isShowRateCard: boolean;
  enableApiCreation: boolean;
  enableUserCreation: boolean;
  enableReportDownload: boolean;
  isCampaignNumberHash: boolean;
  enableRewardCampaignCreation: boolean;
  smsOperatorConfguraion: {
    all: boolean;
    defaultOperator: string | number;
    robi: {
      isUse: boolean;
      systemOperatorId: number;
      userName: string;
      password: string;
      tps: string;
    };
    tl: {
      isUse: boolean;
      systemOperatorId: number;
      userName: string;
      password: string;
      tps: string;
      acode: string;
    };
    bl: {
      isUse: boolean;
      systemOperatorId: number;
      userName: string;
      password: string;
      tps: string;
      billmsisdn: string;
    };
    gp: {
      isUse: boolean;
      systemOperatorId: number;
      userName: string;
      password: string;
      tps: string;
      billmsisdn: string;
    };
  };
  rewardOperatorConfguraion: {
    all: boolean;
    robi: {
      isUse: boolean;
      systemOperatorId: number;
      userName: string;
      password: string;
    };
    tl: {
      isUse: boolean;
      systemOperatorId: number;
      userName: string;
      password: string;
    };
    bl: {
      isUse: boolean;
      systemOperatorId: number;
      userName: string;
      password: string;
      clientId: string;
      grantType: string;
      scope: string;
      clientSecret: string;
      senderMsisdn: string;
    };
    gp: {
      isUse: boolean;
      systemOperatorId: number;
      clientId: string;
      clientSecret: string;
      grantType: string;
    };
  };
}

function ApproveUserList() {
  const INITIAL_FORM_STATE: UserAddValues = {
    id: 0,
    profileImage: "",
    representativeName: "",
    email: "",
    companyName: "",
    industryType: "",
    accountType: "",
    username: "",
    rateCardId: "",
    status: true,
    enableUserCreation: true,
    enableApiCreation: true,
    isShowRateCard: true,
    enableReportDownload: true,
    isCampaignNumberHash: true,
    enableRewardCampaignCreation: true,
    businessName: "",
    dataRateCardId: "",
    companyContact: "",
    smsOperatorConfguraion: {
      all: true,
      defaultOperator: "",
      robi: {
        isUse: true,
        systemOperatorId: 1,
        userName: "",
        password: "",
        tps: "",
      },
      tl: {
        isUse: true,
        systemOperatorId: 2,
        userName: "",
        password: "",
        tps: "",
        acode: "",
      },
      bl: {
        isUse: true,
        systemOperatorId: 3,
        userName: "",
        password: "",
        tps: "",
        billmsisdn: "",
      },
      gp: {
        isUse: true,
        systemOperatorId: 4,
        userName: "",
        password: "",
        tps: "",
        billmsisdn: "",
      },
    },
    rewardOperatorConfguraion: {
      all: true,
      robi: {
        isUse: true,
        systemOperatorId: 1,
        userName: "",
        password: "",
      },
      tl: {
        isUse: true,
        systemOperatorId: 2,
        userName: "",
        password: "",
      },
      bl: {
        isUse: true,
        systemOperatorId: 3,
        userName: "",
        password: "",
        clientId: "",
        grantType: "",
        scope: "",
        clientSecret: "",
        senderMsisdn: "",
      },
      gp: {
        isUse: true,
        systemOperatorId: 4,
        clientId: "",
        clientSecret: "",
        grantType: "",
      },
    },
  };

  const theme: any = useTheme();
  const [search, setSearch] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [users, setUsers] = useState([]);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [count, setCount] = useState(0);

  const [open, setOpen] = useState(false);
  const [dialogTitle, setDialogTitle] = useState("");
  const [initialItem, setInitialItem] = useState(INITIAL_FORM_STATE);
  const path = useLocation();
  const dispatch = useDispatch();
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });

  useEffect(() => {
    const id = path?.pathname;
    dispatch({ type: MENU_OPEN, id });
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchApiUserList(search);
  }, [paginationModel]);

  const fetchApiUserList = (searchValue: string) => {
    setIsLoading(true);
    let formData = {
      userName: searchValue,
    };
    UserService.getApprovePendingOwnerList(formData, paginationModel.page, paginationModel.pageSize).then((response) => {
      if (response.isSuccess) {
        setUsers(response.data.data.rows);
        setCount(response.data.data.count);
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    });
  };

  const handleClickOpen = (dialogTitle: string, formState: UserAddValues) => {
    setOpen(true);
    setDialogTitle(dialogTitle);
    setInitialItem(formState);
  };

  const dialog = useMemo(
    () =>
      ViewEditDialog(ApproveUser)({
        open: open,
        setOpen: setOpen,
        dialogTitle: dialogTitle,
        initialItem: initialItem,
        fetchData: fetchApiUserList,
        theme: theme,
        maxWidth: "lg",
      }),
    [open],
  );

  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const columns = [
    {
      field: "action",
      filterable: false,
      headerName: "",
      sortable: false,
      disableExport: false,
      minWidth: 50,
      maxWidth: 50,
      headerClassName: "stickyActionHeader",
      cellClassName: "stickyColumn",
      renderCell: (params: any) => {
        return (
          <Box>
            <Tooltip title="Edit">
              <IconButton
                aria-label="view"
                color="primary"
                onClick={() => {
                  handleClickOpen(`Aprove API User ID: ${params.row.id}`, {
                    id: params.row.id,
                    profileImage: params.row?.companyImage,
                    representativeName: params.row.representativeName,
                    email: params.row.email,
                    companyName: params.row.companyName,
                    companyContact: params.row.mobile,
                    industryType: params.row.industryType,
                    accountType: Number(params.row.accountType) + 1,
                    username: params.row.userName,
                    rateCardId: "",
                    status: params.row.status,
                    isShowRateCard: true,
                    enableUserCreation: true,
                    enableApiCreation: true,
                    enableReportDownload: true,
                    isCampaignNumberHash: true,
                    enableRewardCampaignCreation: true,
                    businessName: "",
                    dataRateCardId: "",
                    smsOperatorConfguraion: {
                      all: true,
                      defaultOperator: "",
                      robi: {
                        isUse: true,
                        systemOperatorId: 1,
                        userName: "",
                        password: "",
                        tps: "",
                      },
                      tl: {
                        isUse: true,
                        systemOperatorId: 2,
                        userName: "",
                        password: "",
                        tps: "",
                        acode: "",
                      },
                      bl: {
                        isUse: true,
                        systemOperatorId: 3,
                        userName: "",
                        password: "",
                        tps: "",
                        billmsisdn: "",
                      },
                      gp: {
                        isUse: true,
                        systemOperatorId: 4,
                        userName: "",
                        password: "",
                        tps: "",
                        billmsisdn: "",
                      },
                    },
                    rewardOperatorConfguraion: {
                      all: true,
                      robi: {
                        isUse: true,
                        systemOperatorId: 1,
                        userName: "",
                        password: "",
                      },
                      tl: {
                        isUse: true,
                        systemOperatorId: 2,
                        userName: "",
                        password: "",
                      },
                      bl: {
                        isUse: true,
                        systemOperatorId: 3,
                        userName: "",
                        password: "",
                        clientId: "",
                        grantType: "",
                        clientSecret: "",
                        scope: "",
                        senderMsisdn: "",
                      },
                      gp: {
                        isUse: true,
                        systemOperatorId: 4,
                        clientId: "",
                        clientSecret: "",
                        grantType: "",
                      },
                    },
                  });
                }}
              >
                <VisibilityIcon fontSize="inherit" color="primary" />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },
    {
      field: "id",
      filterable: false,
      headerName: "ID",
      sortable: false,
      disableExport: false,
      minWidth: 60,
      maxWidth: 80,
    },
    {
      field: "dp",
      filterable: false,
      headerName: "User",
      sortable: false,
      disableExport: false,
      minWidth: 200,
      renderCell: (params: any) => {
        return (
          <Stack alignItems={"center"} direction={"row"} spacing={1}>
            <Avatar src={`${process.env.REACT_APP_API_PROD}/${params.row?.companyImage}`} />
            <Stack direction={"column"}>
              <Typography>{params?.row?.companyName || ""}</Typography>
              <Typography variant="caption">{params?.row?.representativeName || ""}</Typography>
            </Stack>
          </Stack>
        );
      },
    },
    {
      field: "userName",
      filterable: false,
      headerName: "Username",
      sortable: false,
      disableExport: false,
      minWidth: 150,
      flex: 1,
    },
    {
      field: "email",
      filterable: false,
      headerName: "Email",
      sortable: false,
      disableExport: false,
      minWidth: 200,
      flex: 1,
    },
    {
      field: "accountType",
      filterable: false,
      headerName: "Account Type",
      sortable: false,
      disableExport: false,
      minWidth: 120,
      align: "center" as GridAlignment,
      flex: 1,
      renderCell: (params: any) => {
        return params.row?.accountType === 1 ? (
          <Typography fontWeight={"bold"} variant="overline" color="primary">
            Postpaid
          </Typography>
        ) : (
          <Typography fontWeight={"bold"} variant="overline" color="secondary">
            Prepaid
          </Typography>
        );
      },
    },
    {
      field: "contact",
      filterable: false,
      headerName: "Contact",
      sortable: false,
      disableExport: false,
      minWidth: 150,
      maxWidth: 150,
      flex: 1,
      renderCell: (params: any) => {
        return formatMobile(params.row?.mobile || "");
      },
    },
  ];

  return (
    <Grid container>
      <Grid container justifyContent="center">
        <Grid item xs={12}>
          {/* <MainCard title="Approve Pending Parent User List"> */}
          <Formik
            initialValues={{
              userName: "",
            }}
            validationSchema={Yup.object().shape({
              userName: Yup.string().notRequired(),
            })}
            onSubmit={(values: any, { setSubmitting }) => {
              setPage(0);
              setSearch(values.userName || "");
              fetchApiUserList(values.userName);
            }}
          >
            {({ values, dirty, isSubmitting, isValid, setFieldValue }) => (
              <Form>
                <Grid container justifyContent={"flex-end"} spacing={1}>
                  <Grid item>
                    <TextFieldWrapper
                      label="Search"
                      placeholder="Username.."
                      name="userName"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                      // sx={{ ...theme.typography.customInput }}
                      fullWidth={true}
                    />
                  </Grid>
                  <Grid item>
                    <Button color="primary" variant="contained" sx={{ ...theme.typography.customInput }} type="submit">
                      View
                    </Button>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        </Grid>
        <Grid item xs={12}>
          <Box sx={{ minHeight: 400 }}>
            <DataGrid
              autoHeight
              columns={columns}
              loading={isLoading}
              rows={users}
              slots={{
                noRowsOverlay: EmptyResultDataGrid,
                loadingOverlay: () => <LinearProgress />,
              }}
              style={{ overflow: "auto" }}
              sx={{
                "& .MuiDataGrid-cell.stickyColumn": {
                  position: "sticky",
                  left: 0,
                  backgroundColor: `${theme.palette.mode === "light" ? theme.palette.primary.light : theme.palette.background.paper}`,
                  zIndex: 1,
                },
                "& .clicked-row": {
                  backgroundColor: `${theme.palette.secondary.light} !important`,
                },
                // cursor: "pointer",
              }}
              pagination
              density="standard"
              getRowId={(row: any) => row.id}
              paginationMode="server"
              rowCount={count}
              disableRowSelectionOnClick
              pageSizeOptions={[5, 10, 25, 50, 100]}
              paginationModel={paginationModel}
              onPaginationModelChange={setPaginationModel}
            />
          </Box>
        </Grid>
      </Grid>
      {dialog}
    </Grid>
  );
}

export default ApproveUserList;
